import * as React from 'react';

import EntWebsitePageWrapper from 'bundles/ent-website/components/EntWebsitePageWrapper';
import { DOMAINS } from 'bundles/ent-website/constants/navigation';

const PartnersDomain = () => {
  return <EntWebsitePageWrapper domain={DOMAINS.partners} />;
};

export default PartnersDomain;
